import { render } from "./BuyNft.vue?vue&type=template&id=b021cde8&scoped=true"
import script from "./BuyNft.vue?vue&type=script&lang=js"
export * from "./BuyNft.vue?vue&type=script&lang=js"

import "@/Common/Styles/buyNft.scss?vue&type=style&index=0&id=b021cde8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b021cde8"]])

export default __exports__